import { findParent } from "./findParent";
import { handleRefreshes } from "./handleRefreshes";
export function refreshActiveItem(e) {
    const target = e.target;
    if (target.classList.contains("cp-active__refresh")) {
        const item = findParent(target, "cp-active__item");
        const items = document.querySelectorAll(".cp-active__item");
        items.forEach((item) => {
            item.classList.remove("cp-active__item--refreshing");
            item.classList.remove("cp-active__item--error");
            item.classList.remove(".cp-active__item--success");
        });
        if (item) {
            const pageID = target.getAttribute("data-key");
            item.classList.add("cp-active__item--refreshing");
            handleRefreshes(pageID, {
                error: (error) => {
                    item.classList.remove("cp-active__item--refreshing");
                    item.classList.add("cp-active__item--error");
                    console.error(error);
                },
                success: (count) => {
                    item.classList.remove("cp-active__item--refreshing");
                    if (count > 0) {
                        item.classList.remove("cp-active__item--success");
                    }
                    else {
                        item.classList.add("cp-active__item--error");
                    }
                },
            });
        }
    }
}
